//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

//采购退换货列表页面
const purchaseReturnList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/purchaseReturn/list.vue')),
    'purchaseReturnList'
  );
//采购退换货新增页面
const purchaseReturnAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/purchaseReturn/add.vue')),
    'purchaseReturnAdd'
  );
//采购退换货修改页面
const purchaseReturnEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/purchaseReturn/edit.vue')),
    'purchaseReturnEdit'
  );
//采购退换货详情页面
const purchaseReturnDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/purchaseReturn/detail.vue')),
    'purchaseReturnDetail'
  );
//采购退换货复制页面
const purchaseReturnCopy = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/purchaseReturn/copy.vue')),
    'purchaseReturnCopy'
  );

const purchaseReturnRouter = {
  path: '/purchase',
  component: index,
  children: [
    {
      path: 'purchaseReturnList',
      name: 'purchaseReturnList',
      component: purchaseReturnList,
      meta: {
        keepAlive: true,
        title: '采购退换货列表',
      },
    },
    {
      path: 'purchaseReturnAdd',
      name: 'purchaseReturnAdd',
      component: purchaseReturnAdd,
      meta: {
        keepAlive: true,
        title: '采购退换货新增',
      },
    },
    {
      path: 'purchaseReturnEdit',
      name: 'purchaseReturnEdit',
      component: purchaseReturnEdit,
      meta: {
        keepAlive: true,
        title: '采购退换货修改',
      },
    },
    {
      path: 'purchaseReturnDetail',
      name: 'purchaseReturnDetail',
      component: purchaseReturnDetail,
      meta: {
        keepAlive: true,
        title: '采购退换货详情',
      },
    },
    {
      path: 'purchaseReturnCopy',
      name: 'purchaseReturnCopy',
      component: purchaseReturnCopy,
      meta: {
        keepAlive: true,
        title: '采购退换货复制',
      },
    },
  ],
};
export default purchaseReturnRouter;
